export const Moon_Fill = `<svg title="Moon_Fill" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Style=Fill">
<path id="Filled" d="M11.1455 2.00186C6.02127 2.44387 2 6.74343 2 11.9822C2 17.5149 6.48512 22 12.0178 22C17.2566 22 21.5562 17.9787 21.9981 12.8544C22.0314 12.4691 21.6135 12.2245 21.2657 12.3934C18.0545 13.9526 14.5432 13.7559 12.3943 11.607C10.2451 9.4578 10.0469 5.94589 11.6064 2.7344C11.7754 2.38652 11.5308 1.96863 11.1455 2.00186Z" fill="currentcolor"/>
</g>
</svg>
`;